import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-main-logo',
  templateUrl: './icon-main-logo.component.html',
  styles: []
})
export class IconMainLogoComponent {}
